import React from "react";
import { Box, Skeleton } from "@mui/material";

const MessageLoader = () => {
  return (
    <>
      <Box sx={{ my: 1.5 }}>
        <Skeleton variant="text" sx={{ fontSize: "2rem" }} />
      </Box>
      <Skeleton variant="rounded" height={60} />
      <Box sx={{ my: 1.5 }}>
        <Skeleton variant="rounded" height={60} />
      </Box>
    </>
  );
};

export default MessageLoader;
